import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_b6a89be4";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_b6a89be4" };
/** script content **/
require("./cascade-picker.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findexb6a89be4%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fcascade-picker%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_b6a89be4"],
    ctorType: "component",
    outputPath: "components/indexb6a89be4/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'cube-picker': getComponent(require("../picker/index.mpx?isComponent&outputPath=components%2Findex3b508115%2Findex")) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
